import { reactive, ref } from 'vue';

const model = reactive({
	code: null,
	taxNumber: null,
	name: null,
	contactPerson: null,
	phoneNumber: null,
	contactMail: null,
	privacyPolicyAccepted: null,
	dataChangeAccepted: null,
	captchaKey: null,
	captchaText: null
});

const captchaError = ref(false);

export const useForm = () => {
	return { model, captchaError };
};
